import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { RowLayout } from '../../../../modules/common/layouts/rowLayout/RowLayout';
import { AnnotatingOverviewContainer } from '../../../../modules/projects/project/overview/AnnotatingOverview.container';
import { ClarificationsOverviewContainer } from '../../../../modules/projects/project/overview/ClarificationsOverview.container';
import { ReviewOverviewWidgetContainer } from '../../../../modules/projects/project/overview/ReviewOverview.container';
import { ProjectDetailsGlobalErrorsContainer } from '../../../modules/projectDetails/containers/ProjectOverviewErrors.container';
import { ToolsStatistics } from '../../../modules/projectDetails/sub/statistics/components/ToolsStatistics';
import { ToolStatisticsRefreshButtonContainer } from '../../../modules/projectDetails/sub/statistics/containers/ToolStatisticsRefreshButtonContainer';

export const ProjectDetailsOverviewView = (): ReactElement => (
  <ColumnLayout size='md'>
    <ProjectDetailsGlobalErrorsContainer />
    <RowLayout
      size='md'
      className='overview-card-container'
    >
      <AnnotatingOverviewContainer />
      <ReviewOverviewWidgetContainer />
      <ClarificationsOverviewContainer />
    </RowLayout>
    <ToolStatisticsRefreshButtonContainer />
    <ToolsStatistics />
  </ColumnLayout>
);
